import React from 'react';
import { data } from '../utils/data';
const Home = () => {
  return (
    <div 
    >
      
      <div
        className="relative"
      >
        <img src="https://images.pexels.com/photos/191327/pexels-photo-191327.jpeg" alt="" />
        <div  className="absolute  top-0 left-0 right-0 py-4 bg-gray-800 opacity-70" >
        <h1 className="relative w-full lg:pt-4 text-3xl lg:text-6xl font-extrabold text-white top-8 lg:top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          Bonjour chez notre garage
        </h1>
       </div>
       <div className="absolute  bottom-0 left-0 right-0 px-2 bg-gray-800 opacity-70" >
      <h1 className="relative w-full text-xl lg:text-3xl text-teal-400 bottom-0 left-1/2 -translate-x-1/2">
        Voir quelques-uns de nos services
      </h1>
      </div>
      </div>
      <div className="flex flex-wrap justify-around pt-10 px-4 ">
        {data.map((item) => (
          <div key={item.id}>
            <div className="">
              
              <div className="p-5">
               
                  <h5 className=" mb-2 text-2xl text-blue-700 font-bold tracking-tight  ">
                    {' '}
                    {item.name}
                  </h5>
                
                <p className="mb-3 font-normal dark:text-gray-400 flex space-x-2">
                <img src="https://cdn-icons-png.flaticon.com/512/1023/1023757.png" className="h-5 " ></img><p>{item.description}
                </p></p>
                
                  
               
              </div>
            </div>
           <br /> 
            <hr />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
